import Vue from "vue";
import { CreateApkDetectionResult } from "@/modules/apk/apk.interface";

interface State {
  waitingDetection: CreateApkDetectionResult | null;
}

export const DetectState = Vue.observable<State>({
  // 不为空则显示等待检测遮罩
  waitingDetection: null
});
